module.exports = "https://static.wagwalking.com/_next/static/images/dog-sitting-3-cbbc60ce83beafa4687deed83d5aefba.svg";